import { registerIcons } from '@uifabric/styling'
import {
  Coachmark,
  createTheme,
  Customizer,
  DefaultPalette,
  DirectionalHint,
  getColorFromString,
  getContrastRatio,
  isDark,
  styled,
  TeachingBubble,
  TeachingBubbleContent,
  ThemeGenerator,
  themeRulesStandardCreator,
} from 'office-ui-fabric-react'
import { setDefaultTarget } from 'office-ui-fabric-react/lib/components/Layer/Layer.notification'
import { createElement, useEffect, useMemo, useRef, useState } from 'react'
import { render, unmountComponentAtNode } from 'react-dom'

import { FabricDependencies } from '.'

export const fabricDependencies: FabricDependencies = {
  Coachmark,
  Customizer,
  DefaultPalette,
  DirectionalHint,
  TeachingBubble,
  TeachingBubbleContent,
  ThemeGenerator,
  createElement,
  createTheme,
  getColorFromString,
  getContrastRatio,
  isDark,
  registerIcons,
  render,
  setDefaultTarget,
  styled,
  themeRulesStandardCreator,
  unmountComponentAtNode,
  useEffect,
  useMemo,
  useRef,
  useState,
}
